import React from 'react'
import styles from './TableHeader.module.scss'
import { TableHeaderProps } from './types'
import {
  DragDropContext,
  Droppable,
  DroppableProvided
} from 'react-beautiful-dnd'
import { ColumnLabel } from './ColumnLabel'
import { inject } from 'mobx-react'
import { VIEWERS_STORE } from 'store'

function TableHeaderComponent<TabType> (props: TableHeaderProps<TabType>) {
  const {
    columns,
    [VIEWERS_STORE]: { handleColumnLabelDragEnd }
  } = props

  return (
    <DragDropContext onDragEnd={handleColumnLabelDragEnd}>
      <Droppable droppableId='droppable' direction='horizontal'>
        {(provided: DroppableProvided) => {
          return (
            <div
              ref={provided.innerRef}
              className={styles.header}
              {...provided.droppableProps}
            >
              {columns.map((col, index) =>
                <ColumnLabel
                  key={col.label as unknown as string}
                  column={col}
                  index={index}
                />
              )}
              {provided.placeholder}
            </div>
          )
        }}
      </Droppable>
    </DragDropContext >
  )
}

const TableHeader = inject('VIEWERS_STORE')(TableHeaderComponent)
export { TableHeader }
